export default function validate(values) {
  let errors = {}
  const nameRegex = /[0-9!|@#¢$%&/=?¿^*;:_.,]/

  if (!values.first_name) {
    errors.first_name = 'Your first name is required'
  } else if (values.first_name.trim() === '') {
    errors.first_name = 'Your first name is required'
  } else if (nameRegex.test(values.first_name)) {
    errors.first_name = 'Your first name must not contain symbols or numbers'
  } else if (values.first_name.length > 50) {
    errors.first_name = `Your first name must contain no more than 50 characters.`
  }

  if (!values.last_name) {
    errors.last_name = 'Your last name is required'
  } else if (values.last_name.trim() === '') {
    errors.last_name = 'Your last name is required'
  } else if (nameRegex.test(values.last_name)) {
    errors.last_name = 'Your last name must not contain symbols or numbers'
  } else if (values.last_name.length > 50) {
    errors.last_name = `Your last name must contain no more than 50 characters.`
  }

  if (!values.email) {
    errors.email = 'Your email address is required'
  } else if (!/^[^@]+@.+\.[a-z]{2,}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  if (!values.company) {
    errors.company = 'Company is required'
  } else if (values.company.trim() === '') {
    errors.company = 'Company is required'
  } else if (values.company.length > 50) {
    errors.company = `Your company must contain no more than 50 characters.`
  }

  if (values.job_title && values.job_title.length > 80) {
    errors.job_title = 'Your Job Title must contain no more than 80 characters.'
  }

  if (values.phone_number) {
    const justNumbers = values.phone_number.replace(/\D+/g, '')
    if (justNumbers.length < 7 || justNumbers.length > 25) {
      errors.phone_number = 'Invalid telephone number'
    }
    const noNumbers = values.phone_number.replace(/\d+/g, '')
    const allowed = /(ext|x|\.|-|\(|\)|\/|\+)*/gi
    if (noNumbers.length > 0 && !allowed.test(noNumbers)) {
      errors.phone_number = 'Invalid telephone number'
    }
  }

  if (!values.license) {
    errors.license = 'License is required'
  }

  return errors
}
